/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Save_Completed_ErrorInputs */

const en_save_completed_error = /** @type {(inputs: Save_Completed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Save project completed with error. ${i?.error}`)
};

const fr_save_completed_error = /** @type {(inputs: Save_Completed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enregistrement du projet terminé avec erreur. ${i?.error}`)
};

const de_save_completed_error = /** @type {(inputs: Save_Completed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Projekt mit Fehler gespeichert. ${i?.error}`)
};

const it_save_completed_error = /** @type {(inputs: Save_Completed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Salvataggio del progetto completato con errore. ${i?.error}`)
};

const ru_save_completed_error = /** @type {(inputs: Save_Completed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сохранение проекта завершилось с ошибкой. ${i?.error}`)
};

const es_save_completed_error = /** @type {(inputs: Save_Completed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Guardar proyecto completado con error. ${i?.error}`)
};

const zh_cn2_save_completed_error = /** @type {(inputs: Save_Completed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`项目保存失败。${i?.error}`)
};

const ja_save_completed_error = /** @type {(inputs: Save_Completed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プロジェクトの保存がエラーで完了しました。${i?.error}`)
};

const hi_save_completed_error = /** @type {(inputs: Save_Completed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट सेव करने में त्रुटि आई। ${i?.error}`)
};

const pt_pt2_save_completed_error = /** @type {(inputs: Save_Completed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Projeto salvo concluído com erro. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Save project completed with error. {error}" |
*
* @param {Save_Completed_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const save_completed_error = /** @type {((inputs: Save_Completed_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_Completed_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_save_completed_error(inputs)
	if (locale === "de") return de_save_completed_error(inputs)
	if (locale === "it") return it_save_completed_error(inputs)
	if (locale === "ru") return ru_save_completed_error(inputs)
	if (locale === "es") return es_save_completed_error(inputs)
	if (locale === "zh-CN") return zh_cn2_save_completed_error(inputs)
	if (locale === "ja") return ja_save_completed_error(inputs)
	if (locale === "hi") return hi_save_completed_error(inputs)
	if (locale === "pt-PT") return pt_pt2_save_completed_error(inputs)
	return en_save_completed_error(inputs)
});